module.exports = __webpack_public_path__ + "/images/ico-heart-fill.6d67b4a.svg";